import { Placement } from '@amzn/fire-tv-campaign-automation-service';

/**
 * Configuration defining which features are enabled for each placement type.
 * This centralized config makes it easy to add new placements or modify feature availability.
 *
 * @example
 * // To check if campaign metadata is needed for a placement:
 * const config = PLACEMENT_FEATURE_CONFIG[placement];
 * if (config.showCampaignMetadata) {
 *   // Render campaign metadata section
 * }
 */
export interface PlacementFeatureConfig {
  /** Whether to show the campaign metadata input section */
  showCampaignMetadata: boolean;

  /** Whether to show the publish campaign section */
  showPublishSection: boolean;
}

/**
 * Feature configuration for each placement type.
 * Add new placements here as they are introduced.
 */
export const PLACEMENT_FEATURE_CONFIG: Record<Placement, PlacementFeatureConfig> = {
  [Placement.FEATURE_ROTATOR]: {
    showCampaignMetadata: true,
    showPublishSection: true,
  },

  [Placement.INLINE_DISPLAY_BANNER]: {
    showCampaignMetadata: true,
    showPublishSection: true,
  },
  [Placement.SCREEN_SAVER]: {
    showCampaignMetadata: false,
    showPublishSection: false,
  },
};

/**
 * Helper function to get feature configuration for a specific placement.
 * Provides type-safe access to placement features.
 *
 * @param placement - The placement type to get configuration for
 * @returns Feature configuration object for the placement
 *
 * @example
 * const features = getPlacementFeatures(Placement.SCREEN_SAVER);
 * if (features.showPublishSection) {
 *   // Render publish section
 * }
 */
export function getPlacementFeatures(placement: Placement): PlacementFeatureConfig {
  return PLACEMENT_FEATURE_CONFIG[placement];
}
